<template>
  <div class="h-full">
    <header class="bg-gray-100 flex" :style="headerStyle">
      <span
        class="absolute font-thin right-0 top-0 text-gray-800 hover:text-gray-900 p-5 mr-1 cursor-pointer"
        @click="$emit('close')"
      >
        <font-awesome-icon icon="times" size="lg"></font-awesome-icon>
      </span>
      <span class="absolute font-thin left-0 top-0 p-5" v-if="hasIcon">
        <font-awesome-icon :icon="icon" size="lg"></font-awesome-icon>
      </span>
      <div class="w-full">
        <div class="flex justify-start">
          <slot name="header"></slot>
        </div>
      </div>
    </header>
    <main :class="fullSize ? 'overflow-y-auto' : ''" :style="mainStyle">
      <slot name="main"></slot>
    </main>
  </div>
</template>

<script>
export default {
  props: {
    fullSize: {
      type: Boolean,
      default: false,
      required: false,
    },
    icon: {
      required: false,
      default: null,
    },
  },
  components: {},
  mixins: [],
  data: function () {
    return {};
  },
  methods: {},
  computed: {
    headerStyle() {
      return this.fullSize ? "height: 68px;" : "";
    },

    mainStyle() {
      return this.fullSize ? "height: calc(100vh - 68px);" : "";
    },

    hasIcon() {
      return this.icon !== null && this.icon !== undefined && this.icon !== "";
    },
  },
  mounted() {},
};
</script>

<style></style>
